import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';
import AttributeCondition, {
  isBinaryOperator,
  isRelativeTimestampOperator,
  isAbsoluteTimestampOperator,
  isTwoValueOperator,
  canSelectComparisonOperator,
} from 'cio/app-models/conditions/attribute';
import { deserializeFilter } from 'cio/utils/conditions/deserialize/attribute';
import pluralize from 'cio/utils/pluralize';
import { isEmpty } from '@ember/utils';
import { comparisonOperators } from 'cio/utils/operators';
import { formatWithTimezone } from 'cio/utils/format-with-timezone';

export function getFullAttributeValue(conditionValue: SerializedLegacyAttributeFilter | AttributeCondition): string {
  let condition: AttributeCondition;
  if (conditionValue instanceof AttributeCondition) {
    condition = conditionValue;
  } else {
    condition = deserializeFilter(conditionValue);
  }

  let { operator, comparisonOperator } = condition;
  let shouldFormatTimestamp = isAbsoluteTimestampOperator(operator) || operator === 'timestamp_bw';

  let value = shouldFormatTimestamp
    ? formatWithTimezone(Number(condition.value), 'Etc/GMT') ?? ''
    : condition.value ?? '';

  if (isRelativeTimestampOperator(operator)) {
    let { timestampValue, timeDirection } = condition;
    return `${timestampValue} ${pluralize(Number(timestampValue), 'day')} ${timeDirection}`;
  }

  if (isTwoValueOperator(operator)) {
    let value2 = shouldFormatTimestamp
      ? formatWithTimezone(Number(condition.value2), 'Etc/GMT') ?? ''
      : condition.value2 ?? '';
    return `${value} and ${value2}`;
  }

  if (
    isBinaryOperator(operator) &&
    canSelectComparisonOperator(operator) &&
    !isEmpty(comparisonOperator) &&
    comparisonOperator !== 'value'
  ) {
    let operator = comparisonOperators.find((op) => op.value === comparisonOperator);
    if (operator != null) {
      return `${operator.label} ${value ?? ''}`;
    }
  }

  return value;
}
